// extracted by mini-css-extract-plugin
module.exports = {"overflow":"overflow___1WTlK"};